import React from 'react'
import DescriptionEditor from './DescriptionEditor/DescriptionEditor'

/** Task description: mentions on, story/step links off.
 *  mentionList: 'support' (support + main) or 'tasks' (dev tasks). */
const TaskDescriptionEditor = (props) => (
    <DescriptionEditor
        {...props}
        enableMentions={props.enableMentions ?? true}
        enableAppLinks={props.enableAppLinks ?? false}
        mentionList={props.mentionList ?? 'support'}
    />
)

export default TaskDescriptionEditor
